export enum ColorEnum {
  PURPLE_10 = 'purple-10',
  GRAY_20 = 'gray-20',
  GRAY_10 = 'gray-10',
}
